export const TypePayments = {
  dinheiro: "Dinheiro",
  cheque: "Cheque",
  cartaoDeCredito: "Cartão de Crédito",
  cartaoDeDebito: "Cartão de Débito",
  creditoLoja: "Crédito Loja",
  valeAlimentacao: "Vale Alimentação",
  valeRefeicao: "Vale Refeição",
  valePresente: "Vale Presente",
  valeCombustivel: "Vale Combustível",
  duplicata: "Duplicata Mercantil",
  boletoBancario: "Boleto Bancário",
  depositoBancario: "Depósito Bancário",
  pix: "Pagamento Instantâneo (PIX)",
  transferencia: "Transferência bancária, Carteira Digital",
  programaDeFidelidade: "Programa de fidelidade, Cashback, Crédito Virtual",
  semPagamento: "Sem pagamento"
}